import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Navbar from './components/Navbar';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import SurveyBuilder from './components/SurveyBuilder';
import SurveyTaker from './components/SurveyTaker';
import PerformanceSurveyTaker from './components/PerformanceSurveyTaker';
import EvaluatorDashboard from './components/EvaluatorDashboard';
import Analytics from './components/Analytics';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import './App.css';
  
function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Toaster position="top-right" />
          <AppContent />
        </div>
      </Router>
    </AuthProvider>
  );
}

function AppContent() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={
        <>
          <Navbar />
          <div className="container with-navbar"><Dashboard /></div>
        </>
      } />
      <Route path="/builder" element={
        <>
          <Navbar />
          <div className="container with-navbar"><SurveyBuilder /></div>
        </>
      } />
      {/* Ruta de formularios normales (clima/BIENESTAR) */}
      <Route path="/form/:id/:token" element={<SurveyTaker />} />
      {/* Ruta de desempeño (pares evaluador-evaluado) */}
      <Route path="/performance-form/:id/:token" element={<PerformanceSurveyTaker />} />
      <Route path="/evaluator/:evaluatorToken" element={<EvaluatorDashboard />} />
      {/* Backward-compat alias for older emails */}
      <Route path="/evaluator-dashboard/:evaluatorToken" element={<EvaluatorDashboard />} />
      <Route path="/analytics" element={
        <>
          <Navbar />
          <div className="container with-navbar"><Analytics /></div>
        </>
      } />
      <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} />
    </Routes>
  );
}

export default App; 